import axios from "axios";
import { Button } from "react-bootstrap";
import moment from "moment";
import React, { useRef, useState } from "react";
import { FileDrop } from "react-file-drop";
import { toast } from "react-toastify";
import { AddIconV2 } from "../../../assets/Logos/Icons";
import {
  generateUniqueFileName,
  getFileTypeFromFileName,
} from "../../../Helpers/FileHelper";
import styles from "./index.module.scss";
import ConformModal from "../../Modals/Reusable Modals/ConformModal";
import FileViewModal from "../../Modals/FileViewModal/FileViewModal";
import { SERVER_API_URL } from "../../../apis";
import { removefile } from "../../../actions/GanagabookingAction";
import { useDispatch, useSelector } from "react-redux";
import { UPDATE_SELECTED_STATE_OF_QUESTION } from "../../../actions/type";
import Assets from "../../Layout/Assets";
import ConfirmModalDelete from "../ConfirmModal";
import backUpImage from "../../../assets/backup_FILL0_wght400_GRAD0_opsz24.svg";

function UploadReportComponent({
  files,
  onFileUpload,
  onFileRemove,
  disabled,
  Store_formData,
  appoinment_form,
  reportsSize,
}) {
  const [toastOpen, setToastOpen] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [fileActionModal, setFileActionModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(false);
  const [fileViewModal, setFileVIewModal] = useState(false);
  const [error, setError] = useState(false);
  const [showError, setShowError] = useState(false);
  const [fileItem, setFileName] = useState([]);
  let [errorMessage, setErrorMessage] = useState("File type not supported");
  const [showModal, setShowModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState(
    appoinment_form?.selectedFiles ? appoinment_form?.selectedFiles : []
  );
  const fileInputRefHidden = useRef(null);
  const [clickedFile, setClickedFile] = useState(null);
  let [actionModal, setActionModal] = useState(false);
  const fileInputRef = useRef(null);
  const [deleteItems, setDeleteItem] = useState("");
  const [filecount, setfilecount] = useState(files?.length);

  let fileUploadRef = useRef();
  let uploads = [...files];
  const dispatch = useDispatch();
  const uploadedData = useSelector(
    (state) => state.bookAppoinment.uploadedData?.reportList
  );
  let onUploadClick = () => {
    fileUploadRef.current.click();
  };

  let onFileChange = (file, e) => {
    let uploads = files;

    let restrictions = [
      "pdf",
      "PDF",
    ];

    let ext = file.name.split(".")?.pop();

    if (restrictions.includes(ext.toLowerCase())) {
      let imgSize = parseFloat(file?.size / (1024 * 1024)).toFixed(2);

      if (uploads) {
        if (uploads?.length <= 4) {
          if (imgSize < 5) {
            setError(false);

            const formData = new FormData();
            formData.append("name", file.name);
            formData.append("file", file);

            axios
              .post(SERVER_API_URL + "/reportsuploads", formData, {})
              .then((res) => {
                console.log(res);
                let imgname = res.data.data.fileName?.split("!");

                setFileName([...fileItem, res.data && res.data.data.fileName]);
                setShowError(false);
                onFileUpload([
                  ...uploads,
                  {
                    title: imgname[0],
                    uploaded: moment().format("DD-MM-YYYY"),
                    status: true,
                    filetypes: ext,
                    fileurl: res.data.data.fileurl,
                    resName: res.data.data.fileName,
                    filename: imgname[0],
                  },
                ]);
              })
              .catch((error) => {});
          } else {
            setError(true);
            setErrorMessage("Please select file size less than 5 MB.");

            if (!toastOpen) {
              toast.error("Please select file size less than 5 MB", {
                position: toast.POSITION.TOP_CENTER,
                hideProgressBar: true,
                onOpen: (props) => setToastOpen(true),
                onClose: (props) => setToastOpen(false),
              });
            }
          }
        } else {
          if (!toastOpen) {
            toast.error("Only 5 files are allowed to upload", {
              position: toast.POSITION.TOP_CENTER,
              hideProgressBar: false,
              onOpen: (props) => setToastOpen(true),
              onClose: (props) => setToastOpen(false),
            });
          }
        }
      } else {
        if (imgSize < 5) {
          setError(false);
          const formData = new FormData();
          formData.append("name", file.name);
          formData.append("file", file);

          axios
            .post(SERVER_API_URL + "/reportsuploads", formData, {})
            .then((res) => {
              console.log(res);
              let imgname = res.data.data.fileName?.split("!");

              setFileName([...fileItem, res.data && res.data.data.fileName]);
              setShowError(false);
              onFileUpload([
                {
                  title: imgname[0],
                  uploaded: moment().format("DD-MM-YYYY"),
                  status: true,
                  filetypes: ext,
                  fileurl: res.data.data.fileurl,
                  resName: res.data.data.fileName,
                  filename: imgname[0],
                },
              ]);
            })
            .catch((error) => {});
        } else {
          setError(true);
        }
      }
    } else {
      setError(true);
      setErrorMessage("File type not supported");
      if (!toastOpen) {
        toast.error("File type not supported", {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: false,
          onOpen: (props) => setToastOpen(true),
          onClose: (props) => setToastOpen(false),
        });
      }
    }

    e.target.value = "";
  };

  let handleFileClick = (data) => {
    console.log("file click", data);
    setFileActionModal(true);
    setSelectedFile(data);
  };

  let Updatereports = () => {};

  let handleFilePreviewAction = () => {
    setFileActionModal(false);
    setFileVIewModal(true);
  };

  let handleFileRemoveAction = () => {
    let filteredFiles = files.filter((each) => each.title != selectedFile);
    onFileUpload(filteredFiles);
    setFileActionModal(false);
  };

  let getFileDetailsByName = (name) => {
    if (files && files.length > 0) {
      const _files = files.filter((each) => each.title == name);
      return _files[0];
    }
  };

  const onCancel = (item) => {
    console.log("item on cancel", item);
    dispatch(removefile(item.title))
      .then((res) => {
        // if (res.data.info === "Success") {

        let filter1 = uploads.filter((obj) => {
          return obj.title != item.title;
        });
        let filter2 = fileItem.filter((value) => {
          return value != item.resName;
        });
        onFileUpload(filter1);
        setFileName(filter2);
        dispatch(
          Store_formData({
            ...appoinment_form,
            reports: filter2?.toString(),
            reportsArray: filter1,
          })
        );
        setShowModal(false);
        window.location.reload();
        // } else {
        // }
      })
      .catch((error) => {});
  };

  const selectFiles = (file, index) => {
    if (selectedFiles.includes(file)) {
      let x = [...selectedFiles];
      x = x.filter(function (el) {
        return el.filename != file.filename;
      });
      let y = [...fileItem];
      y = y.filter(function (el) {
        return el.filename != file.filename;
      });
      setSelectedFiles(x);
      setFileName(y);
    } else {
      setSelectedFiles([...selectedFiles, file]);
      // setFileName([...fileItem, file.filename]);
      // setUploads([
      //   ...uploads,
      //   {
      //     title: file.filename,
      //     uploaded: moment().format("DD-MM-YYYY"),
      //     status: true,
      //     resName: res.data.data.fileName,
      //   },
      // ]);
    }
  };
  const isSelected = (file) => {
    // console.log(selectedFiles,file)
    // selectedFiles.filter(function(el) { return el.filename == file.filename })
    if (
      selectedFiles.some(
        (item) =>
          item.filename === file.filename &&
          item.uploadRefId == file.uploadRefId
      )
    ) {
      return true;
    }
    return false;
  };

  let handleGridFileClick = (type, item, key) => {
    console.log("item", type, item, key);
    setClickedFile({ type, item, key });
    setActionModal(true);
  };

  let handleFileViewClick = (e, item, index) => {
    console.log("item", clickedFile.item);
    //e.stopPropagation()
    window.open(clickedFile.item.fileurl, '_blank')
    setClickedFile(clickedFile.item);
    setFileVIewModal(true);
    setActionModal(!actionModal);
  };
  const handleFileViewEyeClick = (e, item, index) => {
    //e.stopPropagation()
    console.log(item);
    setClickedFile(item);
    setFileVIewModal(true);
  };
  let handleFileremoveClick = () => {
    const { type, item } = clickedFile;

    console.log("item", item, type);

    if (type === "fromdb") {
      const _temp = selectedFiles.filter(
        (each) => each.filename != item?.filename
      );
      setSelectedFiles(_temp);
    } else {
      dispatch(removefile(item.title))
        .then((res) => {
          // if (res.data.info === "Success") {
          console.log(res);
          console.log("befor update uploads", uploads);
          console.log("befor update fileItem", fileItem);
          onFileUpload(uploads.filter((each) => each.resName != item?.resName));
          console.log(
            "after removing uploads",
            uploads.filter((each) => each.resName != item?.resName)
          );
          let filter2 = fileItem.filter((value) => {
            return value != item.resName;
          });
          console.log("after filter2", filter2);

          setFileName(filter2);
        })
        .catch((error) => {});

      const _temp = uploads.filter((each) => each.resName != item?.resName);
      //console.log("_temp",_temp)
    }

    setActionModal(false);
  };

  let handleSelectYesNo = (value) => {
    dispatch({
      type: UPDATE_SELECTED_STATE_OF_QUESTION,
      payload: {
        key: "reports",
        value: value,
      },
    });
  };

  const closeFileViewModal = () => {
    setFileVIewModal(false);
  };

  const handleAddNewFileClick = () => {
    if(!uploading && uploads.length + reportsSize < 5 ){
      fileInputRefHidden.current.click();

    }else{
      toast.error('Only 5 files are allowed to upload!')
    }
  };

  console.log("files............", filecount);

  console.log('reportsSize', reportsSize)

  return (
    <div className={styles.container}>
      <div className={styles.uploader_wrap}>
        {(uploads && uploads.length > 0) ||
        (selectedFiles && selectedFiles.length > 0) ? (
          <div className={styles.report_uploader}>
            <div className={styles.upload_button}>
              {/* <input
              accept={[
                ".pdf",
                ".png",
                ".jpeg",
                ".jpg",
                ".doc",
                ".docx",
                ".dcm",
                ".DCM",
                ".zip",
              ]}
              type="file"
              id="upload"
              ref={fileInputRef}
              onChange={(e) => {
                onFileChange(e.target.files[0], e);
              }}
            /> */}
              <FileDrop
                style={{ display: "flex" }}
                className={styles.uploader_body}
                restrictions={{
                  allowedExtensions: [
                    ".pdf",
                  ],
                }}
                onFrameDragEnter={(event) =>
                  console.log("onFrameDragEnter", event)
                }
                onFrameDragLeave={(event) =>
                  console.log("onFrameDragLeave", event)
                }
                onFrameDrop={(event) => console.log("onFrameDrop", event)}
                onDragOver={(event) => console.log("onDragOver", event)}
                onDragLeave={(event) => console.log("onDragLeave", event)}
                onDrop={(files, event) => {
                  event.stopPropagation();
                  !disabled && onFileChange(files[0]);
                }}
              >
                {(uploads && uploads.length > 0) ||
                (selectedFiles && selectedFiles.length > 0) ? (
                  <div className={styles.files_grid}>
                    {uploads &&
                      uploads.map((eachReport, key) => {
                        return (
                          <div
                            className={styles.files_grid_item}
                            onClick={() => {
                              handleGridFileClick("uploads", eachReport, key);
                            }}
                          >
                            <img
                              src={getFileTypeFromFileName(
                                eachReport?.resName?.split("!")[0]
                              )}
                            ></img>
                          </div>
                        );
                      })}

                    {selectedFiles &&
                      selectedFiles.map((eachReport, key) => {
                        return (
                          <div
                            name="fromdb"
                            className={styles.files_grid_item}
                            onClick={() => {
                              handleGridFileClick("fromdb", eachReport, key);
                            }}
                          >
                            <img
                              src={getFileTypeFromFileName(
                                eachReport?.filename
                              )}
                            ></img>
                          </div>
                        );
                      })}
                  </div>
                ) : (
                  <>
                    <label for="upload">
                      <img src={Assets.file_icon}></img>Open Files{" "}
                    </label>
                    <span>
                      (Supported format - PDF. File limits - 5 files of 5MB per file)
                    </span>
                  </>
                )}

                {/* uploads && uploads.map(() => {

}) */}

                {/* <label for="upload">
                  <img src={Assets.file_icon}></img>Open Files{" "}
                </label>
                <span className={Style.imageFormat}>
                  (Supported formats - PDF, PNG, JPEG, JPG, DOC, DOCX, DCM,
                  ZIP. File limits - 5 files of 5MB per file)
                </span> */}
              </FileDrop>
            </div>
          </div>
        ) : (
          <div style={{ width: "500px" }}>
            <div style={{ cursor: "pointer" }}>
              <div
                onClick={handleAddNewFileClick}
                className={styles.addReportButtonAdd}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <input
                  style={{ display: "none" }}
                  accept={[
                    ".pdf",
                  ]}
                  type="file"
                  id="upload"
                  ref={fileInputRefHidden}
                  onChange={(e) => {
                    onFileChange(e.target.files[0], e);
                  }}
                />

                <img
                  src={backUpImage}
                  alt="Backup Image"
                  style={{
                    color: "#258fc3",
                    marginBottom: "5px",
                  }}
                />
                <p
                  style={{
                    fontSize: "16px",
                    marginBottom: "3px",
                  }}
                >
                  Select a file
                </p>
              </div>
            </div>
            <span className={styles.supportformatspan}>
              {" "}
              (Supported format - PDF. File limits - 5 files of 5MB per file)
            </span>
          </div>
        )}
      </div>

      <div style={{ width: "400px" }}>
        {uploads.length > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
              marginBottom:"10px"
            }}
          >
            {!uploading && uploads.length + reportsSize < 5 &&(
              <Button
                className="today_hostory_report_uploader_header"
                onClick={handleAddNewFileClick}
                style={{
                  backgroundColor: "white",
                  border: "1px solid #d9d9d9",
                }}
              >
                <input
                  type="file"
                  onChange={(e) => {
                    onFileChange(e.target.files[0], e);
                  }}
                  ref={fileInputRefHidden}
                  style={{ display: "none" }}
                />

                <span style={{ color: "#1890ff" }}> Select More </span>
              </Button>
            )}
          </div>
        )}

        {uploads.length > 0 && (
          <>
            <span className="supportformatspan2" style={{ padding: "0px" }}>
              {" "}
              (Supported format - PDF. File
              limits - 5 files of 5 MB per file)
            </span>
          </>
        )}
      </div>

      {/* {!files.length >= 5 && ( */}
      <>
        <span className="supportformatspan"> </span>
      </>
      {/* )} */}

      <ConformModal
        title="Choose your action"
        okText="Preview"
        closeText="Remove"
        caption=""
        onOk={handleFileViewClick}
        onClose={handleFileremoveClick}
        isShowModal={actionModal}
      />

      <ConfirmModalDelete
        showModal={showModal}
        setShowModal={setShowModal}
        onCancel={onCancel}
        deleteItems={deleteItems}
      />

      {/* <FileViewModal
        isShowModal={fileViewModal}
        onClose={closeFileViewModal}
        file={clickedFile}
      /> */}
    </div>
  );
}

export default UploadReportComponent;
